import apiFetch from "../utils/fetch";

export function userChartCreate(data, callback, errorcallback) {
    apiFetch(window.appConfig.apiServer + '/user-chart', {
        method: 'POST',
        body: JSON.stringify(data),
    }).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function userChartEdit(data, callback, errorcallback) {
    apiFetch(window.appConfig.apiServer + '/user-chart/edit/' + data._id, {
        method: 'PUT',
        body: JSON.stringify(data),
    }).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function userChartGet(id, callback, errorcallback) {
    apiFetch(window.appConfig.apiServer + '/user-chart/' + id).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function userChartGetByDashboardID(data, callback, errorcallback) {
    apiFetch(window.appConfig.apiServer + '/user-chart/user/' + data.userId + '/dashboard/' + data.dashboardID).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function userChartGetAllActive(username, callback, errorcallback) {
    apiFetch(window.appConfig.apiServer + '/user-chart/user/' + username + "/active/true").then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function userChartDelete(id, callback, errorcallback) {
    apiFetch(window.appConfig.apiServer + '/user-chart/' + id, {
        method: 'DELETE',
    }).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}